class TabSwitchers extends HTMLElement {
  constructor() {
    super(),
      (this.activeClass = "active"),
      (this.buttons = this.querySelectorAll(".tab-switchers .button")),
      (this.tabs = this.querySelectorAll(".tab-content .tab")),
      this.buttons.forEach((t) =>
        t.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(t) {
    t.preventDefault();
    let s = t.currentTarget,
      e = this.querySelector(
        '.tab[id="' + t.currentTarget.dataset.target + '"]'
      );
    this.tabs.forEach((t) => t.classList.remove(this.activeClass)),
      this.buttons.forEach((t) => t.classList.remove(this.activeClass)),
      s.classList.add(this.activeClass),
      e.classList.add(this.activeClass);
  }
}
customElements.define("tab-switchers", TabSwitchers);
